module.exports = __webpack_public_path__ + "static/media/play_last_card_mobile.537a94ee.png";